// Search menu state
import PatcraftApi from "../../../scripts/patcraft-api";

// Initial state
const state = () => ({
  scope: "all", // current scope option: all, collections, styles, colors...
  searchTerm: "",
  collections: [],
  products: [],
  pages: [],
  displayPriority: "",
  isFetching: false,
  madeInitialFetch: false
});

// Getters
const getters = {
  scope: (state, getters, rootState) => {
    return state.scope;
  },
  searchTerm: state => {
    return state.searchTerm;
  },
  collections: state => {
    return state.collections;
  },
  products: state => {
    return state.products;
  },
  displayPriority: state => {
    return state.displayPriority;
  },
  pages: state => {
    return state.pages;
  },
  isFetching: state => {
    return state.isFetching;
  },
  showNoResults: state => {
    return (
      state.madeInitialFetch &&
      !state.isFetching &&
      state.pages.length === 0 &&
      state.collections.length === 0
    );
  }
};

// Actions
const actions = {
  setScope({ commit, state }, scope) {
    commit("setScope", { scope });
  },
  setSearchTerm({ commit, state }, query) {
    commit("setSearchTerm", { query });
  },
  fetchQuickSearchResults({ commit, state, dispatch }) {
    if (state.isFetching) {
      return;
    }
    dispatch("setIsFetching", true);
    PatcraftApi.getQuickSearchResults(state.searchTerm.trim())
      .then(res => {
        commit("setResultsCollections", { results: [...res.data.collections] });
        commit("setResultsProducts", { results: [...res.data.products] });
        commit("setResultsPages", { results: [...res.data.pages] });
        commit("setDisplayPriority", { value: res.data.displayPriority });
        dispatch("setIsFetching", false);
        if (!state.madeInitialFetch) {
          dispatch("setMadeInitialFetch", true);
        }
      })
      .catch(error => {
        dispatch("setIsFetching", false);
      });
  },
  setResultsCollections({ commit }, results) {
    commit("setResultsCollections", { results });
  },
  setResultsProducts({ commit }, results) {
    commit("setResultsProducts", { results });
  },
  setResultsPages({ commit }, results) {
    commit("setResultsPages", { results });
  },
  setDisplayPriority({ commit }, value) {
    commit("setDisplayPriority", { value });
  },
  setIsFetching({ commit }, value) {
    commit("setIsFetching", { value });
  },
  setMadeInitialFetch({ commit }, value) {
    commit("setMadeInitialFetch", { value });
  }
};

// Mutations
const mutations = {
  setScope(state, { scope }) {
    state.scope = scope;
  },
  setSearchTerm(state, { query }) {
    state.searchTerm = query;
  },
  setResultsCollections(state, { results }) {
    state.collections = [...results];
  },
  setResultsProducts(state, { results }) {
    state.products = [...results];
  },
  setResultsPages(state, { results }) {
    state.pages = [...results];
  },
  setDisplayPriority(state, { value }) {
    state.displayPriority = value;
  },
  setIsFetching(state, { value }) {
    state.isFetching = value;
  },
  setMadeInitialFetch(state, { value }) {
    state.madeInitialFetch = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
